const { h, render, Component } = require('preact');
const Banner = require ('./banner.js')

class Header extends Component {
  constructor(props) {
    super(props)

  }

  shouldComponentUpdate() {
    var headerBanner = document.getElementById("header-banner")
    if (headerBanner)
      headerBanner.setAttribute("style", "display:null")
  }
  getBannerText() {
    return `${Groupon.Utils.getConfigFromDom().bannerText}`
  }

  decodeEntities(encodedString) {
     var textArea = document.createElement('textarea');
        textArea.innerHTML = encodedString;
      return textArea.value;
  }

  render() {
      var bannerTextKey = this.getBannerText();
      var bannerText = I18n.translate('js.modules.shared.' + bannerTextKey)
      bannerText = this.decodeEntities(bannerText)
      if (bannerText != "$") {
          return (
              <div class="header-class" id="header-banner">
                  <Banner/>
              </div>
          )
      }
  }
}

module.exports = Header